<div *ngIf="!news">
  <app-loading-spinner></app-loading-spinner>
</div>
<div *ngIf="news">
  <app-navbar></app-navbar>
  <div class="container p-5">
    <div class="row">
      <div *ngFor="let book of news" class="col-sm-6 col-md-4  p-2">
        <mdb-card>
          <div class="view overlay waves-light" mdbWavesEffect>
            <!-- Card img -->
            <mdb-card-img
              class="card-img"
              [src]="book.image"
              alt="card.title"
            ></mdb-card-img>
            <a>
              <div class="mask rgba-white-slight"></div>
            </a>
          </div>
          <!--Card content-->
          <mdb-card-body>
            <!--Title-->
            <mdb-card-title>
              <h4>{{ book.title }}</h4>
            </mdb-card-title>

            <!--Text-->
            <mdb-card-text>
              {{ book.description }}
            </mdb-card-text>

            <a [routerLink]="[book.id]" mdbBtn color="primary" mdbWavesEffect
              >Read More
            </a>
          </mdb-card-body>
        </mdb-card>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
